<script lang="ts">
  import Icon from "@shared/svelte/Components/Icon.svelte";
  const SignupHero = window["C"].IMAGE_PATHS["signup_hero_sf.png"];

</script>

<div data-grid-area="aside">
  <section class="fizz-hide-on-large fizz-space-between">
    <h4 class="fizz-heading-4">The Best of SevenFifty is Now in Provi</h4>
    <!-- svelte-ignore a11y-missing-attribute -->
    <img src={SignupHero} alt="" width="90" />
  </section>
  <section class="fizz-hide-on-small">
    <h2 class="fizz-heading-2 fizz-stack-4">The Best of SevenFifty is Now in Provi</h2>
    <p class="fizz-text-medium fizz-stack-32">
      Now with SevenFifty's portfolios as part of the Provi marketplace, it's easier than ever to
      find and order the brands you want at the prices you need.
    </p>

    <ul class="fizz-flow-32 fizz-stack-32">
      <li>
        <div class="fizz-flex-row-12 fizz-align-content-start">
          <Icon type="Tick" height="24" width="24" />
          <div>
            <p class="fizz-text-large fizz-stack-4">
              <strong>Find exactly what you need from 750K+ products</strong>
            </p>
            <p class="fizz-text-medium">
              Robust search options like filtering portfolios by price or product type make
              browsing, discovering and ordering a breeze.
            </p>
          </div>
        </div>
      </li>
      <li>
        <div class="fizz-flex-row-12 fizz-align-content-start">
          <Icon type="Tick" height="24" width="24" />
          <div>
            <p class="fizz-text-large fizz-stack-4">
              <strong>Send your orders easily and efficiently</strong>
            </p>
            <p class="fizz-text-medium">
              Use quick-order lists to make reorders in 5 minutes or less and make stocking your
              inventory the simplest part of your week.
            </p>
          </div>
        </div>
      </li>
      <li>
        <div class="fizz-flex-row-12 fizz-align-content-start">
          <Icon type="Tick" height="24" width="24" />
          <div>
            <p class="fizz-text-large fizz-stack-4">
              <strong>Keep in touch with all your reps</strong>
            </p>
            <p class="fizz-text-medium">
              A single hub to review order histories, chat with reps and get updates and alerts on
              orders.
            </p>
          </div>
        </div>
      </li>
    </ul>
    <!-- svelte-ignore a11y-missing-attribute -->
    <img src={SignupHero} class="fizz-margin-auto" />
  </section>
</div>
